import SommercialSelect from "../my-element-select/index"
import MessageList from "../my-messageList/index"
import ButtonEmpty  from "../my-button-empty/index"
import mylistBoxTc  from "../my-listBox-tc/index"
const components = [
    SommercialSelect,
    MessageList,
    ButtonEmpty,
    mylistBoxTc
]
const install = function(Vue){
     components.forEach(component=>{
         Vue.component(component.name,component);
     })
}
export default{
    install
}



// WEBPACK FOOTER //
// ./src/components/utils/index.js